import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ApiKeyFormState } from './api-key-form.reducer';
import { apiKeyFormProjectsAdapter } from './api-key-form.adapter';

export const ApiKeyFormKey = 'apiKeyForm';

export const getApiKeyFormState = createFeatureSelector<ApiKeyFormState>(ApiKeyFormKey);

export const getApiKeyFormModel = createSelector(
  getApiKeyFormState,
  (state: ApiKeyFormState) => state.model,
);

export const getApiKeyFormError = createSelector(
  getApiKeyFormState,
  (state: ApiKeyFormState) => state.error,
);

export const getApiKeyFormLoaded = createSelector(
  getApiKeyFormState,
  (state: ApiKeyFormState) => state.loaded,
);

export const getApiKeyFormMode = createSelector(
  getApiKeyFormState,
  (state: ApiKeyFormState) => state.mode,
);

export const apiKeyFormProjectsSelectors = apiKeyFormProjectsAdapter.getSelectors();
